import React, { useContext, useEffect, useState, useRef } from "react";
import AddToFavourite from "./favouriteCompaniesCTA";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import { Modal } from "react-bootstrap";
import { Info, MoreVertical } from "react-feather";
import axios from "axios";
import { getApiUrl } from "../../utils/baseUrl";
import SalesforceDuplicateModal from "../salesforce-duplicate-modal";
import AddFavModal from "../AddFavModal";
import { GLOBAL_ENUM } from "../../core/dictionary/global";
import { getRemainingValueAddCredits } from "../../core/utility/utility";
import trackingEventDictionary from "../../../src/core/dictionary/tracking-event";
import ContactModal from "./contactModal";
import FeatureNudge from "./FeatureNudge";
import ShipmentConfigureModal from "../shipmentConfigureModal";
import commaFormat from "../../utils/commaFormat";
import { globalPendoEventForCompanyRedirection } from "../../../src/core/global/global-country-functions";
import { redirectionCompanyTypeDictionary as redirectionCompanyTypeEnum, tabHeadingDictionary } from "../../../src/core/global/global-country-dictionary";
import { globalCountryDetailsDictionary } from "../../../src/core/global/global-country-details";
import { ContextData } from "../../containers/shipments/shipments";
import { useSelector } from "react-redux";
import { profileType } from "@utils/enum";
import Button from "@components/base/button";
import ExportCrmModal from "@shared/ExportCrmModal";
import UpgradeIconSmall from "@assets/images/zap-icon.svg";
import GetInTouchPopup from "@components/templates/Profile/ShipmentDistribution/GetInTouchPopup";
import DynamicDropdown from "@components/base/DynamicDropDown/DynamicDropDown";
import AddCompaniesToWorkspaceModal from "@routes/workspace/components/AddCompaniesToWorkspaceModal";
const credits = {
  Shipments: 1,
  Shipment: 1,
  Importer: 5,
  Exporter: 5,
  Logistics: 5,
};
const apiEndPoint = {
  sendcompanyProfileToSalesforce: getApiUrl("sendcompanyProfileToSalesforce"),
  sendcompanyProfileToHubspot: getApiUrl("sendcompanyProfileToHubspot"),
  exportCompaniesToHubspot: getApiUrl("exportCompaniesToHubspot"),
  sendcompanyProfileToZoho: getApiUrl("sendcompanyProfileToZoho"),
};

const TabHeader = ({ prospectData, type, selectedData, userCredit, creditQuota, totalDataCount, onDownload, defaultData, onSelect, onClear, isTrademoAccount, tradeDirection, country, dataSource, isSalesForceRedirection, setAddToFav, analyticsCountryID, pathname, currentUserPlan, isRedirect, redirectingCompanyExporterId, redirectingCompanyImporterId, userFirstPlan, getUserPlan, isTwoLevel, isMerged, redirectionCompanyType, showBolFilter, applyUIUEFilterHandler, trendsTab, allFilters, finalReqObj, currentTab, source }) => {
  const { setType, defaultType, setCustomLoader } = useContext(ContextData);
  const userDetails = useSelector((state) => state?.userDetails?.userData);
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const STARTERPLAN = creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("starter"))?.navigate === "search";
  const STARTERPLANCOUNTRY = creditDetails?.data?.[0]?.user_active_plan ?? "";
  const [showFavModal, setShowFavModal] = useState(false);
  const [showDownloadImpExpModal, setShowDownloadImpExpModal] = useState(false);
  const [showDownloadShipmentModal, setShowDownloadShipmentModal] = useState(false);
  const [downloadFromValue, setDownloadFromValue] = useState(1);
  const [downloadToValue, setDownloadToValue] = useState(100);
  const [selectAllDownloadFromPopup, setSelectAllDownloadFromPopup] = useState(false);
  const [isEmailShipments, setIsEmailShipments] = useState(false);
  const [downloadFromModel, setDownloadFromModel] = useState(false);
  const [confirmationModel, setConfirmationModel] = useState(false);
  const [crmCredConfirmation, setCrmCredConfirmation] = useState(false);
  const [activeCRM, setActiveCRM] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateCount, setDuplicateCount] = useState(null);
  const [duplicateData, setDuplicateData] = useState([]);
  const [fuzzyData, setFuzzyData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showCrmModal, setShowCrmModal] = useState(false);
  const [showExportOptions, setShowExportOptions] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showContactsDrop, setShowContactsDrop] = useState(false);
  const isSalesforceUser = userDetails?.is_salesforce_active ? true : false;
  const isZohoUser = userDetails?.is_zoho_active ? true : false;
  const isHubspotUser = userDetails?.is_hubspot_active ? true : false;
  const [showSalesforceModal, setShowSalesforceModal] = useState(false);
  const [showHubspotModal, setShowHubspotModal] = useState(false);
  const [showZohoModal, setShowZohoModal] = useState(false);
  const [showShipmentGridConfigureModal, setShowShipmentGridConfigureModal] = useState(false);
  const [showCustomGridDownloadPopup, setShowCustomGridDownloadPopup] = useState(false);
  const [isCustomGridDownload, setIsCustomGridDownload] = useState(false);
  //start of crm by range
  const [showExportCrmConfirmModal, setShowExportCrmConfirmModal] = useState(false);
  const [exportFromValue, setExportFromValue] = useState(1);
  const [exportToValue, setExportToValue] = useState(500);
  const shipmentDetails = useSelector((state) => state.shipmentDetails);
  const searchParameters = useSelector((state) => state?.shipmentDetails?.searchParameters);

  //end of crm by range
  const { MERGE } = GLOBAL_ENUM;
  const dropdownRef = useRef(null);
  const [showGetInTouch, setShowGetInTouch] = useState(false);
  const [getInTouchType, setGetInTouchType] = useState("");
  const [showAddWorkspaceModal, setShowAddWorkspaceModal] = useState(false);

  const remainingValueAddCount = getRemainingValueAddCredits(creditQuota);
  const IS_DRIPCAP_USER = userDetails.organisationId === "b66d8232-f9bf-479b-8f46-50efb25ec8ea";
  const SHOW_HUBSPOT_DRIP = defaultData.redirectionID === "inmr3_imports" && currentTab === tabHeadingDictionary.importers;
  const ORG_ID = userDetails.organisationId;
  const isWorkspaceSupportedType = type?.toLowerCase() === "importer" || type?.toLowerCase() === "exporter";
  const workspaceCompanyType = type?.toLowerCase() === "importer" ? "buyer" : type?.toLowerCase() === "exporter" ? "supplier" : "";
  // A multi-country search already carries its sources on the request object (dataSource array / "multi_country").
  // For a single data source that key is absent, so attach it (as an array, matching the multi-country shape)
  // so the workspace re-runs against the same source it was created from. The per-country defaultData omits the
  // human-readable source label, so resolve it from the global dictionary by redirectionID (e.g. "mexico imports").
  const workspaceCreationFilters = (() => {
    const base = finalReqObj || {};
    const existingSource = base.dataSource;
    if (Array.isArray(existingSource) ? existingSource.length > 0 : existingSource === "multi_country") return base;
    const singleSource = defaultData?.dataSource || Object.values(globalCountryDetailsDictionary).find((country) => country?.redirectionID && country.redirectionID === defaultData?.redirectionID)?.dataSource;
    if (!singleSource) return base;
    return { ...base, dataSource: [singleSource] };
  })();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowExportOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const contactsReqTypes = [
    {
      name: "Employee Level Contacts",
      cb: () => {
        if (prospectData.length <= userFirstPlan.contact_max_request - userFirstPlan.contact_current_request) {
          setShowContactModal(true);
        } else {
          const displayMessage = "You can request contacts for " + userFirstPlan.contact_max_request + " companies in a day. You can request for " + (userFirstPlan.contact_max_request - userFirstPlan.contact_current_request) + " more companies as you have already requested contacts for " + userFirstPlan.contact_current_request + " companies today.";
          toast.warning(displayMessage);
        }
      },
    },
    {
      name: "Extracted Contacts",
      cb: async () => {
        try {
          const company_ids = [];
          prospectData.map((item) => {
            if (!!item && !!item.key && (!!item.shipper_company_id || !!item.consignee_company_id || !!item.hashed_id)) {
              company_ids.push(item.hashed_id ? item.hashed_id : item.shipper_company_id ? item.shipper_company_id : item.consignee_company_id);
            }
          });
          const { data, status } = await axios.post(getApiUrl("CompanyContactDetails/fetchBulkAIContacts"), { company_ids });
          if (data?.message && status === 200) {
            toast.success(data.message);
          } else {
            toast.error(data.message);
          }
        } catch (error) {
          toast.error("Failed to fetch AI contact");
        }
      },
    },
  ];

  const crmOptionsPriority = [
    {
      name: "Salesforce",
      condition: isSalesforceUser,
      onClick: (e) => {
        addToSalesforce(e, type);
        setShowExportOptions(false);
      },
      modal: setShowSalesforceModal,
      disabledText: "Salesforce",
    },
    {
      name: "Zoho",
      condition: isZohoUser,
      onClick: (e) => {
        addToZoho(e, type);
        setShowExportOptions(false);
      },
      modal: setShowZohoModal,
      disabledText: "Zoho",
    },
    {
      name: "Hubspot",
      condition: isHubspotUser,
      onClick: (e) => {
        addToHubspot(e, type);
        setShowExportOptions(false);
      },
      modal: setShowHubspotModal,
      disabledText: "Hubspot",
    },
  ];

  const getIntegratedCRMInfo = () => {
    const integrations = [
      { name: "Salesforce", isActive: isSalesforceUser, handler: (e) => addToSalesforce(e, type) },
      { name: "Zoho", isActive: isZohoUser, handler: (e) => addToZoho(e, type) },
      {
        name: "Hubspot",
        isActive: isHubspotUser,
        handler: (e) => {
          if (IS_DRIPCAP_USER && prospectData.length === 0) {
            addToHubspotByRange(e, type, []);
          } else if (IS_DRIPCAP_USER && prospectData.length > 0) {
            addToHubspotByRange(e, type, prospectData);
          } else {
            addToHubspot(e, type);
          }
        },
      },
    ];

    const activeCRMs = integrations.filter((crm) => crm.isActive);
    return {
      count: activeCRMs.length,
      activeCRM: activeCRMs[0],
    };
  };

  useEffect(() => {
    if (totalDataCount < downloadToValue) {
      setDownloadToValue(totalDataCount);
    }
  }, [totalDataCount, downloadToValue]);

  const pendoEventForFilterOnStrip = (tab, isTrends) => {
    let redirectingFromProfile = new URLSearchParams(location.search).get("redirectingFrom");

    if (tab === "Importer") {
      if (isTrends) {
        if (redirectingFromProfile) {
          checkPendoEventForCompanyRedirection(`${redirectingFromProfile}_redirection_unique_importer_tab_trends_strip_selection_apply_filter`);
        } else {
          checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImporterTabTrendsStripSelectionApplyFilter);
        }
      } else {
        if (redirectingFromProfile) {
          checkPendoEventForCompanyRedirection(`${redirectingFromProfile}_redirection_unique_importer_tab_rank_strip_selection_apply_filter`);
        } else {
          checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImporterTabRankStripSelectionApplyFilter);
        }
      }
    } else if (tab === "Exporter") {
      if (isTrends) {
        if (redirectingFromProfile) {
          checkPendoEventForCompanyRedirection(`${redirectingFromProfile}_redirection_unique_exporter_tab_trends_strip_selection_apply_filter`);
        } else {
          checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExporterTabTrendsStripSelectionApplyFilter);
        }
      } else {
        if (redirectingFromProfile) {
          checkPendoEventForCompanyRedirection(`${redirectingFromProfile}_redirection_unique_exporter_tab_rank_strip_selection_apply_filter`);
        } else {
          checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExporterTabRankStripSelectionApplyFilter);
        }
      }
    }
  };
  const showConfirmModal = () => {
    if (selectedData.length <= 0) {
      toast.error("Please select atleast one " + type.toLowerCase() + ".");
      return false;
    }
    if (type.toLowerCase() === "importer") {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabSelectionStripDownload);
    } else if (type.toLowerCase() === "exporter") {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSelectionStripDownload);
    } else {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabSelectionStripDownload);
    }
    const totalCount = creditQuota.download_credits.credits_consumed + selectedData.length * credits[type];
    if (totalCount > creditQuota.download_credits.credit_limit) {
      toast.error(`You do not have sufficient credits available to download ${selectedData.length} unique ${type.toLowerCase()}.`); // added beacause below code was not working -arindam
    } else {
      setConfirmationModel(true);
      setDownloadFromValue(1);
      setDownloadToValue(totalDataCount < downloadToValue ? totalDataCount : 100);
      setIsEmailShipments(false);
    }
  };
  const closeDuplicateModalFunction = () => {
    setShowDuplicateModal(false);
  };
  const showDownloadPopup = () => {
    if (!!type && type.toLowerCase() !== "shipments") {
      setShowDownloadImpExpModal(true);
      if (type.toLowerCase() === "importer") {
        checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabDownloadExcelButtonClick);
      } else if (type.toLowerCase() === "exporter") {
        checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabDownloadExcelButtonClick);
      } else {
        checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabDownloadExcelButtonClick);
      }
    } else if (!!type && type.toLowerCase() === "shipments") {
      setShowDownloadShipmentModal(true);
      setSelectAllDownloadFromPopup(false);
      checkPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabDownloadExcelButtonClick);
    }
    setDownloadFromValue(1);
    setDownloadToValue(totalDataCount < downloadToValue ? totalDataCount : 100);
    setIsEmailShipments(false);
  };
  const downloadImpExpPopupClose = () => {
    setShowDownloadImpExpModal(false);
  };
  const downloadShipmentPopupClose = () => {
    setShowDownloadShipmentModal(false);
    setTimeout(() => {
      setIsCustomGridDownload(false);
    }, 200);
    // if (!!type && type.toLowerCase() === 'shipments') {
    //   checkPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabDownloadExcelDownloadShipments);
    // }
  };
  const closeCRMCredConfModal = () => {
    setCrmCredConfirmation(false);
  };
  const closeConfirmModal = () => {
    setConfirmationModel(false);
    setIsCustomGridDownload(false);
  };
  const closeSalesforceModal = () => {
    setShowSalesforceModal(false);
  };
  const closeHubspotModal = () => {
    setShowHubspotModal(false);
  };
  const closeZohoModal = () => {
    setShowZohoModal(false);
  };
  const mapDownloadFromValue = (data) => {
    if (!!data && data <= 0) {
      data = 1;
    }
    setDownloadFromValue(data);
    setSelectAllDownloadFromPopup(false);
    setIsEmailShipments(checkForEmailOrDownload(+downloadToValue - +data));
  };
  const mapDownloadToValue = (data) => {
    if (data > 100000 && totalDataCount > 100000 && (currentTab === tabHeadingDictionary.importers || currentTab === tabHeadingDictionary.exporters)) {
      setDownloadToValue(100000);
    } else if (totalDataCount < data) {
      setDownloadToValue(totalDataCount);
    } else {
      setDownloadToValue(data);
    }
    setSelectAllDownloadFromPopup(false);
    setIsEmailShipments(checkForEmailOrDownload(+data - +downloadFromValue));
  };

  //for crm popup - start
  const mapExportFromValue = (data) => {
    if (+data && +data <= 0) {
      data = 1;
    }
    setExportFromValue(+data);
  };

  const mapExportToValue = (data) => {
    if (100000 < +data) {
      setExportToValue(100000);
    } else {
      setExportToValue(+data);
    }
  };
  //for crm popup - end
  const checkForEmailOrDownload = (data) => {
    if (data >= 500) {
      return true; // for Email
    } else {
      return false; // for Download
    }
  };
  const toggleSelectAllDownloadFromPopup = () => {
    setSelectAllDownloadFromPopup(!selectAllDownloadFromPopup);
    if (selectAllDownloadFromPopup === false || downloadToValue - downloadFromValue + 1 > 500) {
      //todo
      setIsEmailShipments(checkForEmailOrDownload(totalDataCount));
    } else {
      setIsEmailShipments(checkForEmailOrDownload(0));
    }
  };
  const showImporterConfirmModal = () => {
    if (+downloadToValue < +downloadFromValue) {
      toast.error("TO value must be greater than FROM value");
      return false;
    }
    if ((downloadToValue - downloadFromValue + 1) * credits[type] > creditQuota.download_credits.credit_limit - creditQuota.download_credits.credits_consumed) {
      downloadImpExpPopupClose();
      toast.error("You do not have sufficient credits available to download XXX ".replace("XXX", downloadToValue - downloadFromValue + 1) + type + ".");
      return false;
    }
    // this is for download xls using API having email true
    // end of the above logic
    downloadImpExpPopupClose();
    // document.getElementById("downloadfrommodel").style.display = "block";
    setDownloadFromModel(true);
  };
  const closeDownloadFromModal = () => {
    setDownloadFromModel(false);
  };
  const addToSalesforce = (e, type) => {
    e.stopPropagation();
    if (type.toLowerCase() === "importer".toLowerCase()) {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabSelectionStripAddToSalesforce);
    } else if (type === "exporter") {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSelectionStripAddToSalesforce);
    } else {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabSelectionStripAddToSalesforce);
    }
    const requestObject = [];
    prospectData.map((item) => {
      if (!!item && !!item.key && (!!item.shipper_company_id || !!item.consignee_company_id || !!item.hashed_id)) {
        requestObject.push(item.hashed_id ? item.hashed_id : item.shipper_company_id ? item.shipper_company_id : item.consignee_company_id);
      }
    });
    axios.post(apiEndPoint.sendcompanyProfileToSalesforce, { company_id: requestObject }).then(
      (res) => {
        if (!!res && !!res.data && !!res.data.data) {
          if (res.data.status.toLowerCase() === "success") {
            if (res.data.data.description.toLowerCase() === "All Companies are Created".toLowerCase()) {
              toast.success(res.data.data.message);
            } else if (res.data.data.description.toLowerCase() === "All Companies are Duplicate!".toLowerCase()) {
              setShowDuplicateModal(true);
              setDuplicateCount(JSON.parse(res.data.data.duplicate_Result).Duplicate_Companies.length);
              setDuplicateData(JSON.parse(res.data.data.duplicate_Result).Duplicate_Companies);
              setFuzzyData(JSON.parse(res.data.data.fuzzy_Result));
            } else if (res.data.data.description.toLowerCase() === "Rest all Companies Created!".toLowerCase()) {
              setShowDuplicateModal(true);
              setDuplicateCount(JSON.parse(res.data.data.duplicate_Result).Duplicate_Companies.length);
              setDuplicateData(JSON.parse(res.data.data.duplicate_Result).Duplicate_Companies);
              setFuzzyData(JSON.parse(res.data.data.fuzzy_Result));
            }
          } else {
            toast.error("Something went wrong. Please try again after sometime!!!");
          }
        } else {
          toast.error("Something went wrong. Please try again after sometime!!!");
        }
      },
      () => {
        toast.error("Something went wrong. Please try again after sometime!!!");
      }
    );
  };
  const addToHubspot = (e, type) => {
    e.stopPropagation();
    if (type.toLowerCase() === "importer".toLowerCase()) {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabSelectionStripAddToHubspot);
    } else if (type === "exporter") {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSelectionStripAddToHubspot);
    } else {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabSelectionStripAddToHubspot);
    }
    const requestObject = [];
    prospectData.map((item) => {
      if (!!item && !!item.key && (!!item.shipper_company_id || !!item.consignee_company_id || !!item.hashed_id)) {
        requestObject.push(item.hashed_id ? item.hashed_id : item.shipper_company_id ? item.shipper_company_id : item.consignee_company_id);
      }
    });
    axios.post(apiEndPoint.sendcompanyProfileToHubspot, { company_id: requestObject }).then(
      (res) => {
        if (!!res && !!res.data && !!res.data) {
          if (res.data.status.toLowerCase() === "success") {
            toast.success("Company sent successfully to Hubspot");
          } else {
            toast.error(res.data.data);
          }
        } else {
          toast.error("Something went wrong. Please try again after sometime!!!");
        }
      },
      () => {
        toast.error("Something went wrong. Please try again after sometime!!!");
      }
    );
  };

  const addToZoho = (e, type) => {
    e.stopPropagation();
    if (type.toLowerCase() === "importer".toLowerCase()) {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabSelectionStripAddToZoho);
    } else if (type.toLowerCase() === "exporter".toLowerCase()) {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSelectionStripAddToZoho);
    } else {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabSelectionStripAddToZoho);
    }
    const requestObject = [];
    prospectData.map((item) => {
      if (!!item && !!item.key && (!!item.shipper_company_id || !!item.consignee_company_id || !!item.hashed_id)) {
        requestObject.push(item.hashed_id ? item.hashed_id : item.shipper_company_id ? item.shipper_company_id : item.consignee_company_id);
      }
    });
    axios.post(apiEndPoint.sendcompanyProfileToZoho, { company_id: requestObject }).then(
      (res) => {
        if (!!res && !!res.data && !!res.data.data) {
          if (res.data.status && res.data.status.toLowerCase() === "success") {
            if (res.data.data.status && res.data.data.status.toLowerCase() === "complete".toLowerCase()) {
              toast.success("Company sent successfully to Zoho");
            } else if (res.data.data.status && res.data.data.status.toLowerCase() === "duplicate".toLowerCase()) {
              toast.error(res.data.data.message);
            } else if (res.data.data.description && res.data.data.description.toLowerCase() === "Rest all Companies Created!".toLowerCase()) {
              toast.error(res.data.data.description);
            }
          }
        } else {
          toast.error("Something went wrong. Please try again after sometime!!!");
        }
      },
      () => {
        toast.error("Something went wrong. Please try again after sometime!!!");
      }
    );
  };

  const addToHubspotByRange = async (e, type, prospectData) => {
    e.stopPropagation();
    if (type.toLowerCase() === "importer".toLowerCase()) {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabSelectionStripAddToHubspot);
    } else if (type === "exporter") {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSelectionStripAddToHubspot);
    } else {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabSelectionStripAddToHubspot);
    }
    const requestObject = {};
    let selectedFilterState = {};
    let filtersApplied = [];

    let _payload = shipmentDetails?.appliedFilter;
    for (let i = 0; i < allFilters.length; i++) {
      //for normal filters: key="derivedConsigneeMasterName"
      if (_payload[allFilters[i].key]?.length > 0 && !allFilters[i]?.altKey) {
        selectedFilterState[allFilters[i].key] = _payload[allFilters[i].key];
        if (_payload[allFilters[i].key]) {
          filtersApplied = [...filtersApplied, allFilters[i].key];
        }
      } // for regional filters : key="inboundCountryRegion", altKey="inboundCountry"
      else if (_payload[allFilters[i].altKey] && Object.keys(_payload[allFilters[i].altKey])?.length > 0) {
        selectedFilterState[allFilters[i].altKey] = _payload[allFilters[i].altKey];
        selectedFilterState[allFilters[i].key] = [];
        if (_payload[allFilters[i].altKey]) {
          filtersApplied = [...filtersApplied, allFilters[i].altKey];
        }
      }
    }

    requestObject.company_id = [];
    requestObject.organisation_id = ORG_ID;
    requestObject.export_input = searchParameters?.dataSource;

    // do not remove below block of code

    // requestObject.user_query = {
    //   from_range: exportFromValue,
    //   to_range: exportToValue,
    //   search: searchParameters?.searchedItem,
    //   queryType: searchParameters?.matchType,
    //   key: searchParameters?.searchCategory,
    //   fromDate: moment(fromAccutalArrivalDate).format("YYYY-MM-DD"),
    //   toDate: moment(toAccutalArrivalDate).format("YYYY-MM-DD"),
    //   filtersApplied: filtersApplied,
    // };
    // Object.keys(selectedFilterState).map((item) => (requestObject.user_query[item] = selectedFilterState[item]));

    // do not remove above block of code

    if (prospectData.length > 0) {
      let tempIdArr = [];
      prospectData.map((item) => {
        if (!!item && !!item.key && (!!item.shipper_company_id || !!item.consignee_company_id || !!item.hashed_id)) {
          tempIdArr = [...tempIdArr, item.hashed_id ? item.hashed_id : item.shipper_company_id ? item.shipper_company_id : item.consignee_company_id];
        }
      });
      requestObject.company_id = tempIdArr;

      requestObject.user_query = {
        companyType: finalReqObj.companyType,
      };
    }

    if (prospectData.length === 0) {
      requestObject.user_query = {
        ...finalReqObj,
        from_range: exportFromValue,
        to_range: exportToValue,
      };
    }
    try {
      const response = await axios.post(apiEndPoint.exportCompaniesToHubspot, requestObject);
      if (response?.data) {
        const { status } = response;

        if (status === 200) {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
      } else {
        toast.error("Invalid response received. Please try again after sometime!");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || "Something went wrong. Please try again after sometime!";
      toast.error(errorMessage);
    }
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleCrmModalClose = () => {
    setShowCrmModal(false);
  };

  const handleFavModalClose = () => {
    setShowFavModal(false);
  };

  const checkPendoEventForCompanyRedirection = (event) => {
    globalPendoEventForCompanyRedirection(event, isRedirect, redirectingCompanyExporterId, redirectingCompanyImporterId, analyticsCountryID, pathname, currentUserPlan);
  };
  useEffect(() => {
    const globalClickHandler = (e) => {
      if (document.getElementById("export-option-parent") && document.getElementById("export-option-parent").contains(e.target)) {
        setShowExportOptions(true);
      } else if (!((document.getElementById("custom-grid-download-popup-id") && document.getElementById("custom-grid-download-popup-id").contains(e.target)) || (document.getElementById("shipment-default-download-excel-button") && document.getElementById("shipment-default-download-excel-button").contains(e.target)))) {
        if (!isRedirect && (!isZohoUser || !isSalesforceUser || !isHubspotUser)) setShowExportOptions(false);
        setShowCustomGridDownloadPopup(false);
      }
    };

    window.addEventListener("click", globalClickHandler);
    return () => window.removeEventListener("click", globalClickHandler);
  }, [isRedirect, isZohoUser, isSalesforceUser, isHubspotUser]);

  const pendoEventHandler = () => {
    if (type === "Importer") {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSelectionStripFetchBulkContactsFetchContacts);
    } else if (type === "exporter") {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabSelectionStripFetchBulkContactsFetchContacts);
    } else {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabSelectionStripFetchBulkContactsFetchContacts);
    }
  };

  const closeEventHandler = () => {
    if (type === "Importer") {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabDelectionStripFetchBulkContactsClose);
    } else if (type === "exporter") {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSelectionStripFetchBulkContactsClose);
    } else {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabSelectionStripFetchBulkContactsClose);
    }
  };

  return (
    <>
      {type.toLowerCase() === "importer" || type.toLowerCase() === "exporter" || type.toLowerCase() === "logistics" ? (
        <div className={`d-flex align-items-center tw-pr-1 tw-flex-wrap tw-gap-2 ${prospectData.length > 0 ? "" : "d-none"}`}>
          {prospectData.length > 0 ? (
            <>
              <button className="tw-flex tw-items-center tw-px-0 tw-mx-1 !tw-bg-transparent tw-gap-2">
                <span className="tw-text-xs tw-font-semibold tw-text-primary-purple-600 tw-bg-primary-purple-100 tw-rounded-xl tw-px-2 tw-py-1">{prospectData.length}</span>
                <span className="tw-text-xs tw-font-semibold tw-text-primary-purple-600">{prospectData.length === 1 ? " row selected" : " rows selected"}</span>

                <span onClick={() => onClear(type)} className="material-symbols-outlined tw-cursor-pointer  tw-text-primary-purple-600">
                  close
                </span>
              </button>
              <span className="tw-w-[1px] tw-h-[24px] tw-bg-gray-300"></span>
            </>
          ) : (
            <></>
          )}

          {/* Always visible Download button */}
          <Button
            variant="secondaryWithIcon"
            size="small"
            onClick={
              !!prospectData && prospectData.length === 0
                ? () => showDownloadPopup()
                : (e) => {
                    e.stopPropagation();
                    showConfirmModal();
                  }
            }
            className="tw-font-semibold tw-text-xs tw-flex tw-items-center tw-h-8">
            <span className="material-symbols-outlined tw-w-5">cloud_download</span>
            Download
          </Button>

          <>
            <React.Fragment className={`${prospectData.length > 0 ? "" : "d-none"}`}>
              {type.toLowerCase() !== "logistics" && !isTwoLevel ? (
                <div className="tw-relative" data-for="exportToCRM" data-tip={STARTERPLAN ? "Upgrade your plan to export to crm." : prospectData.length === 0 ? "To perform this action, you need to select records from the table." : prospectData.length > 100 ? "Please select upto 100 companies" : ""}>
                  {(IS_DRIPCAP_USER ? SHOW_HUBSPOT_DRIP : true) && (
                    <Button
                      variant="secondaryWithIcon"
                      size="small"
                      onClick={(e) => {
                        if (STARTERPLAN) {
                          setShowGetInTouch(true);
                          setGetInTouchType("exportToCRM");
                          return;
                        }
                        if (!!type && type.toLowerCase() !== "shipments") {
                          //crm click
                          const { count, activeCRM } = getIntegratedCRMInfo();
                          if (count === 0) {
                            setShowCrmModal(true);
                          } else if (count === 1) {
                            if (activeCRM.name === "Hubspot" && IS_DRIPCAP_USER) {
                              if (prospectData.length === 0) {
                                //zero selection
                                setShowExportCrmConfirmModal(true);
                              } else {
                                setCrmCredConfirmation(true);
                                setActiveCRM(activeCRM);
                              }
                            } else {
                              activeCRM.handler(e);
                            }
                          } else {
                            setShowExportOptions(!showExportOptions);
                          }
                          // Track events
                          if (type.toLowerCase() === "importer") {
                            checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabExportToCRMButtonClick);
                          } else if (type.toLowerCase() === "exporter") {
                            checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabExportToCRMButtonClick);
                          }
                        } else {
                          onSelect(downloadShipmentPopupClose);
                        }
                      }}
                      disabled={(isSalesforceUser || isHubspotUser || isZohoUser) && !STARTERPLAN && !IS_DRIPCAP_USER ? (prospectData.length === 0 || prospectData.length > 100) && !STARTERPLAN : false}
                      className={`${STARTERPLAN ? "tw-opacity-50" : ""} tw-font-semibold tw-text-xs tw-flex tw-items-center disabled:tw-cursor-not-allowed tw-h-8`}
                      id="export-option-parent">
                      <span className="material-symbols-outlined tw-w-5">ios_share</span>
                      <span className={`${STARTERPLAN ? "tw-flex tw-gap-1" : ""} tw-font-semibold`}>
                        {(() => {
                          const { count, activeCRM } = getIntegratedCRMInfo();
                          if (count === 1) {
                            return `Export to ${activeCRM.name}`;
                          }
                          return "Export to CRM";
                        })()}
                        {STARTERPLAN && <img src={UpgradeIconSmall} alt="..." className="img-fluid mr-1" />}
                      </span>
                    </Button>
                  )}
                  {type && type.toLowerCase() !== "shipments" && showExportOptions && getIntegratedCRMInfo().count > 1 ? (
                    <span ref={dropdownRef} className="position-absolute tw-cursor-pointer tw-border-gray-200 tw-left-0 tw-px-4 tw-pt-3 tw-border-[1px] tw-border-solid tw-w-[190px] tw-shadow-button tw-rounded-lg tw-bg-white tw-top-9 tw-z-10">
                      {crmOptionsPriority
                        .filter((option) => option.condition && type.toLowerCase() !== "logistics") // Filter out based on user access
                        .map((option) => (
                          <span key={option.name}>
                            {prospectData.length > 0 ? (
                              <span className={`d-flex justify-content-between align-items-center tw-leading-5 tw-text-gray-900 tw-mb-3`} onClick={option.onClick}>
                                {option.name}
                              </span>
                            ) : (
                              <>
                                <span data-for={option.name.toLowerCase()} data-tip={`To perform this action, you need to select records from the table.`} className="d-flex justify-content-between align-items-center tw-mb-3 tw-text-gray-900">
                                  {option.name}
                                </span>
                                <ReactTooltip id={option.name.toLowerCase()} className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="right" />
                              </>
                            )}
                          </span>
                        ))}
                    </span>
                  ) : (
                    <></>
                  )}
                  {showGetInTouch && getInTouchType === "exportToCRM" ? <GetInTouchPopup showGetInTouchPopup={showGetInTouch} handleGetInTouchClose={() => setShowGetInTouch(false)} requestType={"Export to CRM"} notifyCountry={STARTERPLANCOUNTRY} blockAccessType={"feature"} /> : null}
                  {(isSalesforceUser || isZohoUser || isHubspotUser || STARTERPLAN) && !IS_DRIPCAP_USER && <ReactTooltip id="exportToCRM" className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />}
                </div>
              ) : (
                <></>
              )}

              {!isTwoLevel ? (
                <>
                  {!!type && type.toLowerCase() !== "shipments" && isSalesForceRedirection !== true ? (
                    <>
                      <span>
                        <div data-for="addtofavourites" data-tip={prospectData.length === 0 ? "To perform this action, you need to select records from the table." : prospectData.length > 100 ? "Please select upto 100 companies" : "Save companies in the companies bookmark list for easy access."}>
                          <AddToFavourite disabled={prospectData.length === 0 || prospectData.length > 100 ? true : false} isRedirect={isRedirect} analyticsCountryID={analyticsCountryID} pathname={pathname} currentUserPlan={currentUserPlan} prospectData={prospectData} type={type} tradeDirection={tradeDirection} country={country} dataSource={dataSource} triggerPendo={(e) => checkPendoEventForCompanyRedirection(e)} />
                        </div>
                      </span>
                      <ReactTooltip id="addtofavourites" className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
                    </>
                  ) : (
                    <></>
                  )}
                  {isWorkspaceSupportedType && (
                    <>
                      <span id="add_to_workspace_nudge" data-for="addtoworkspace" data-tip={prospectData.length === 0 ? "To perform this action, you need to select records from the table." : prospectData.length > 100 ? "Please select upto 100 companies" : "Add selected companies to workspace"}>
                        <Button variant="secondaryWithIcon" size="small" className="tw-font-semibold tw-text-xs tw-flex tw-items-center disabled:tw-cursor-not-allowed tw-h-8" disabled={prospectData.length === 0 || prospectData.length > 100} onClick={() => setShowAddWorkspaceModal(true)}>
                          <span className="material-symbols-outlined tw-w-5">folder_open</span>
                          <span className="ml-1">Add to Workspace</span>
                        </Button>
                      </span>
                      <ReactTooltip id="addtoworkspace" className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
                    </>
                  )}
                  {!!type && type.toLowerCase() !== "shipments" && type.toLowerCase() !== "logistics" ? (
                    <>
                      {isRedirect && isMerged && prospectData.length < 2 && ((type.toLowerCase() === "importer".toLowerCase() && redirectionCompanyType === redirectionCompanyTypeEnum.importer.value) || (type.toLowerCase() === "exporter".toLowerCase() && redirectionCompanyType === redirectionCompanyTypeEnum.exporter.value)) ? (
                        <></>
                      ) : (
                        <span data-for="mergeCmpany" data-tip={prospectData.length < 2 ? "Please select at least 2 companies" : prospectData.length > 100 ? "Please select upto 100 companies" : "Merge companies to view their consolidated trade information"}>
                          <Button
                            variant="secondaryWithIcon"
                            size="small"
                            className="  tw-font-semibold tw-text-xs tw-flex tw-items-center disabled:tw-cursor-not-allowed tw-h-8"
                            disabled={prospectData.length < 2 || prospectData.length > 100 ? true : false}
                            // data-for="mergeCmpany"
                            onClick={() => {
                              if (type.toLowerCase() === "importer".toLowerCase()) {
                                checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabSelectionStripMerge);
                              } else if (type.toLowerCase() === "exporter".toLowerCase()) {
                                checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSelectionStripMerge);
                              }
                              if (prospectData.length > 1 && prospectData.length < 101) {
                                setShowModal(true);
                                setAddToFav(false);
                              }
                            }}>
                            <span className="material-symbols-outlined tw-w-5">cell_merge</span>
                            <span className="ml-1">Merge</span>
                          </Button>
                        </span>
                      )}

                      <ReactTooltip id="mergeCmpany" className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
                    </>
                  ) : (
                    <></>
                  )}

                  {!!type && type.toLowerCase() !== "shipments" ? (
                    <>
                      <>
                        <DynamicDropdown
                          isOpen={showContactsDrop}
                          onToggle={() => {
                            if (STARTERPLAN) {
                              setShowGetInTouch(true);
                              setGetInTouchType("fetchcontact");
                              return;
                            }
                            if (type.toLowerCase() === "importer".toLowerCase()) {
                              checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabSelectionStripFetchBulkContactsButtonClick);
                            } else if (type.toLowerCase() === "exporter".toLowerCase()) {
                              checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSelectionStripFetchBulkContactsButtonClick);
                            } else {
                              checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabSelectionStripFetchBulkContactsButtonClick);
                            }

                            // Credit check
                            if (userFirstPlan.view_email_details_max_allowed - prospectData.length < 0 && userFirstPlan.view_phone_details_max_allowed - prospectData.length < 0) {
                              return toast.error("You do not have enough credits to fetch the contacts. Please reach out to customersuccess@trademo.com for more credits.");
                            }

                            setShowContactsDrop(!showContactsDrop);
                          }}
                          onClose={() => setShowContactsDrop(false)}
                          icon={{
                            before: true,
                            onOpen: "contacts",
                            onClose: "contacts",
                          }}
                          buttonLabel={
                            STARTERPLAN ? (
                              <span className="tw-flex tw-gap-1">
                                Fetch Contacts
                                <img src={UpgradeIconSmall} alt="..." className="img-fluid mr-1" />
                              </span>
                            ) : (
                              "Fetch Contacts"
                            )
                          }
                          options={contactsReqTypes}
                          buttonId="fetch-contacts-btn"
                          disabled={(prospectData.length === 0 || prospectData.length > 100) && !STARTERPLAN}
                          tooltipConfig={{
                            id: "fetchcontact",
                            message: STARTERPLAN ? "Upgrade your plan to fetch contacts." : prospectData.length === 0 ? "To perform this action, you need to select records from the table." : prospectData.length > 100 ? "Please select upto 100 companies" : "Request contacts for selected companies",
                          }}
                          buttonClassName="  tw-h-8 tw-font-semibold tw-text-xs"
                          dropdownClassName="tw-shadow-sideDrawer tw-border-gray-300 tw-min-w-[220px] tw-left-1"
                        />
                        <ReactTooltip id="fetchcontact" className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
                      </>
                      {showGetInTouch && getInTouchType === "fetchcontact" ? <GetInTouchPopup showGetInTouchPopup={showGetInTouch} handleGetInTouchClose={() => setShowGetInTouch(false)} requestType={"Fetch Contacts"} notifyCountry={STARTERPLANCOUNTRY} blockAccessType={"feature"} /> : null}
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}
              {prospectData.length > 0 ? (
                <Button variant="secondaryWithIcon" size="small" className="tw-h-8 tw-font-semibold tw-text-xs tw-flex tw-items-center disabled:tw-cursor-not-allowed" id="shipment-default-download-excel-button" onClick={() => showDownloadPopup()}>
                  <MoreVertical stroke="#667085" size={16} />
                  <span className="ml-1">More Download Options</span>
                </Button>
              ) : null}

              {prospectData.length > 0 && type !== "Logistics" ? (
                <Button
                  variant="secondaryWithIcon"
                  size="small"
                  className="tw-h-8   tw-font-semibold tw-text-xs tw-flex tw-items-center disabled:tw-cursor-not-allowed"
                  onClick={() => {
                    applyUIUEFilterHandler(prospectData.map((row) => ({ company_name: row.key, company_id: row?.hashed_id || row?.shipper_company_id || row?.consignee_company_id })));
                    pendoEventForFilterOnStrip(type, trendsTab);
                  }}
                  id="shipment-default-download-excel-button">
                  <span className="material-symbols-outlined">filter_arrow_right</span>
                  <span className="ml-1">Apply Filter</span>
                </Button>
              ) : null}
            </React.Fragment>
          </>

          {/* Hidden AddToFavourite component for reference */}
          {!isTwoLevel && !!type && type.toLowerCase() !== "shipments" && isSalesForceRedirection !== true && (
            <div className="tw-hidden">
              <AddToFavourite className="add-to-favourite-button" disabled={prospectData.length === 0 || prospectData.length > 100 ? true : false} isRedirect={isRedirect} analyticsCountryID={analyticsCountryID} pathname={pathname} currentUserPlan={currentUserPlan} prospectData={prospectData} type={type} tradeDirection={tradeDirection} country={country} dataSource={dataSource} triggerPendo={(e) => checkPendoEventForCompanyRedirection(e)} />
            </div>
          )}
        </div>
      ) : (
        <>
          {prospectData && prospectData.length > 0 ? (
            <div className="d-flex align-items-center">
              <div className={`d-flex align-items-center tw-pr-1 ${prospectData.length > 0 ? "" : "d-none"}`}>
                <span className="">
                  {prospectData.length > 0 ? (
                    <div className="tw-flex tw-items-center">
                      <div className="uiue-tabheader-selected-search-count tw-flex tw-items-center px-0 tw-mx-1 tw-text-xs">
                        <span className="tw-text-xs tw-font-semibold tw-text-primary-purple-600 tw-bg-primary-purple-100 tw-rounded-xl tw-px-2 tw-py-1">{prospectData.length}</span>
                        <span className="tw-text-xs tw-font-semibold tw-text-primary-purple-600">{prospectData.length === 1 ? " row selected" : " rows selected"}</span>

                        <span onClick={() => onClear(type)} className="material-symbols-outlined tw-cursor-pointer tw-text-primary-purple-600">
                          close
                        </span>
                      </div>
                      <span className="tw-w-[1px] tw-h-[24px] tw-bg-gray-300"></span>
                    </div>
                  ) : (
                    <></>
                  )}
                </span>
                {/* <span className="vr mx-1"></span> */}
                <span className="tw-relative">
                  <Button
                    variant="secondaryWithIcon"
                    size="small"
                    className="tw-h-8 tw-font-semibold tw-text-xs tw-flex tw-items-center disabled:tw-cursor-not-allowed"
                    id="export-option-parent"
                    onClick={() => {
                      if (!!type && type.toLowerCase() !== "shipments") {
                        setShowExportOptions(!showExportOptions);
                      } else if (defaultData && defaultData.customShipmentGrid === true) {
                        setShowCustomGridDownloadPopup(!showCustomGridDownloadPopup);
                      } else {
                        onSelect(downloadShipmentPopupClose, isCustomGridDownload);
                      }
                    }}>
                    <span className="material-symbols-outlined tw-w-5">cloud_download</span>
                    <span>{type && type.toLowerCase() !== "shipments" ? "Export" : "Download"}</span>

                    {showCustomGridDownloadPopup ? (
                      <div className={`position-absolute tw-cursor-pointer tw-border-[#eaecf0] tw-px-4 tw-pt-3 tw-border-[1px] tw-border-solid tw-w-[190px] tw-shadow-button tw-rounded-lg tw-bg-white tw-top-9 tw-z-10 tw-left-0`}>
                        <span
                          className={`d-flex tw-font-semibold tw-text-xs justify-content-between align-items-center tw-leading-5 tw-text-gray-900 tw-mb-3`}
                          onClick={() => {
                            setConfirmationModel(true);
                            checkPendoEventForCompanyRedirection(trackingEventDictionary.downloadAllColumnShipments);
                          }}>
                          All Columns
                        </span>
                        <span
                          className={`d-flex tw-font-semibold tw-text-xs justify-content-between align-items-center tw-leading-5 tw-text-gray-900 tw-mb-3`}
                          onClick={() => {
                            setIsCustomGridDownload(true);
                            setConfirmationModel(true);
                            checkPendoEventForCompanyRedirection(trackingEventDictionary.downloadShipmentGridColumns);
                          }}>
                          Columns Shown in Grid
                        </span>
                      </div>
                    ) : (
                      <></>
                    )}
                  </Button>
                </span>
              </div>
              <div className=""></div>
              <Button variant="secondaryWithIcon" size="small" className="tw-h-8 tw-font-semibold tw-text-xs tw-flex tw-items-center disabled:tw-cursor-not-allowed" id="shipment-default-download-excel-button" onClick={() => showDownloadPopup()}>
                <MoreVertical stroke="#667085" size={16} />
                <span>More Download Options</span>
              </Button>
            </div>
          ) : (
            <div className="d-flex tw-relative justify-content-between w-100">
              <div>
                <Button
                  variant="secondaryWithIcon"
                  size="small"
                  className="tw-h-8 tw-font-semibold tw-text-xs tw-flex tw-items-center disabled:tw-cursor-not-allowed"
                  onClick={
                    defaultData && defaultData.customShipmentGrid === true
                      ? (e) => {
                          setShowCustomGridDownloadPopup(!showCustomGridDownloadPopup);
                          e.stopPropagation();
                        }
                      : () => showDownloadPopup()
                  }>
                  <span className="material-symbols-outlined tw-w-5">cloud_download</span>
                  <span>Download</span>
                </Button>
                {showCustomGridDownloadPopup ? (
                  <div className={`position-absolute tw-cursor-pointer tw-border-gray-200 tw-left-0 tw-px-4 tw-pt-3 tw-border-[1px] tw-border-solid tw-w-[190px] tw-shadow-button tw-rounded-lg tw-bg-white tw-top-9 tw-z-10`}>
                    <span
                      className={`d-flex tw-font-semibold tw-text-xs justify-content-between align-items-center tw-leading-5 tw-text-gray-900 tw-mb-3`}
                      onClick={() => {
                        showDownloadPopup();
                        setShowCustomGridDownloadPopup(false);
                        checkPendoEventForCompanyRedirection(trackingEventDictionary.downloadAllColumnShipments);
                      }}>
                      All Columns
                    </span>
                    <span
                      className={`d-flex tw-font-semibold tw-text-xs justify-content-between align-items-center tw-leading-5 tw-text-gray-900 tw-mb-3`}
                      onClick={() => {
                        showDownloadPopup();
                        setIsCustomGridDownload(true);
                        setShowCustomGridDownloadPopup(false);
                        checkPendoEventForCompanyRedirection(trackingEventDictionary.downloadShipmentGridColumns);
                      }}>
                      Columns Shown in Grid
                    </span>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              {defaultData && defaultData.customShipmentGrid === true ? (
                <div className="d-flex">
                  <Button
                    variant="secondaryWithIcon"
                    size="small"
                    className="tw-h-8 tw-font-semibold tw-text-xs tw-flex tw-items-center disabled:tw-cursor-not-allowed"
                    onClick={() => {
                      setShowShipmentGridConfigureModal(true);
                      checkPendoEventForCompanyRedirection(trackingEventDictionary.configureDataColumnsButton);
                    }}>
                    <span className="material-symbols-outlined tw-w-5">dashboard_customize</span> <span>Customise Shipment Grid</span>
                  </Button>
                </div>
              ) : (
                <></>
              )}
            </div>
          )}
        </>
      )}
      {/* below code is for configure shipment grid modal */}
      {showShipmentGridConfigureModal ? (
        <ShipmentConfigureModal
          showBolFilter={showBolFilter}
          showModal={showShipmentGridConfigureModal}
          closeModal={(type) => {
            setShowShipmentGridConfigureModal(false);
            if (type === "reset") {
              setType(defaultType);
              setCustomLoader(true);
              setTimeout(() => {
                setCustomLoader(false);
              }, 100);
            }
          }}
        />
      ) : (
        <></>
      )}
      {/* below code is for confirmation of credit deduction for crm export */}
      <Modal size="md" centered show={crmCredConfirmation} onHide={closeCRMCredConfModal} animation={false} className="confirm-modal">
        <Modal.Header>
          <div className="w-100 d-flex">
            <div className="col-md-6 m-auto">
              <span className="header-confirm">Confirmation</span>
            </div>
            <div className="col-md-6 text-right pr-0">
              <button
                className="btn btn-primary trademo-new-btn mx-2 px-2 "
                onClick={(e) => {
                  activeCRM.handler(e);
                  closeCRMCredConfModal();
                }}>
                Confirm
              </button>
              <button type="button" className="close trademo-modal-close" aria-label="Close" onClick={() => closeCRMCredConfModal()}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <p className="modaltext mb-0">
            You are about to export list of{" "}
            <strong>
              {prospectData && prospectData.length > 0 ? prospectData.length : exportToValue - exportFromValue + 1} Prospect {type}
            </strong>{" "}
            which will cost you <strong>{(prospectData && prospectData.length > 0 ? prospectData.length : exportToValue - exportFromValue + 1) * credits[type]} Download Credits.</strong>
          </p>
        </Modal.Body>
      </Modal>
      {/* end code for confirmation of credit deduction for crm export */}
      {/* end of configure shipment grid modal code */}
      {/* below code is for unique importer exporter confirmation popup */}
      <Modal size="md" centered show={confirmationModel} onHide={closeConfirmModal} animation={false} className="confirm-modal">
        <Modal.Header>
          <div className="w-100 d-flex">
            <div className="col-md-6 m-auto">
              <span className="header-confirm">Confirmation</span>
            </div>
            <div className="col-md-6 text-right pr-0">
              <button className="btn btn-primary trademo-new-btn mx-2 px-2 " onClick={() => onSelect(closeConfirmModal, isCustomGridDownload)}>
                Confirm
              </button>
              <button type="button" className="close trademo-modal-close" aria-label="Close" onClick={() => closeConfirmModal()}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <p className="modaltext mb-0">
            You are downloading list of{" "}
            <strong>
              {prospectData.length} Prospect {type}
            </strong>{" "}
            which will cost you <strong>{prospectData.length * credits[type]} Download Credits.</strong>
          </p>
        </Modal.Body>
      </Modal>
      {/* end of the above code */}
      {/* below code is for unique importer exporter export to salesforce upgrade popup */}
      <Modal size="sm" centered show={showSalesforceModal} onHide={closeSalesforceModal} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Upgrade</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row m-0">
            <div className="col-12 p-0">
              <span className="upgrade-text">
                You do not have access to Salesforce Integration. Get in touch with{" "}
                <a href="mailto:customersuccess@trademo.com">
                  <strong>customersuccess@trademo.com</strong>
                </a>{" "}
                for more details.
              </span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2" onClick={() => closeSalesforceModal()}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
      {/* end of the above code */}
      {/* below code is for unique importer exporter export to hubspot upgrade popup */}
      <Modal size="sm" centered show={showHubspotModal} onHide={closeHubspotModal} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Upgrade</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row m-0">
            <div className="col-12 p-0">
              <span className="upgrade-text">
                You do not have access to Hubspot Integration. Get in touch with{" "}
                <a href="mailto:customersuccess@trademo.com">
                  <strong>customersuccess@trademo.com</strong>
                </a>{" "}
                for more details.
              </span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2" onClick={() => closeHubspotModal()}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
      {/* end of the above code */}
      {/* below code is for unique importer exporter export to zoho upgrade popup */}
      <Modal size="sm" centered show={showZohoModal} onHide={closeZohoModal} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Upgrade</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row m-0">
            <div className="col-12 p-0">
              <span className="upgrade-text">
                You do not have access to Zoho Integration. Get in touch with{" "}
                <a href="mailto:customersuccess@trademo.com">
                  <strong>customersuccess@trademo.com</strong>
                </a>{" "}
                for more details.
              </span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2" onClick={() => closeZohoModal()}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
      {/* end of the above code */}
      {/* below code is for unique importer exporter confirmation popup */}
      <Modal size="md" centered show={downloadFromModel} onHide={closeDownloadFromModal} animation={false} className="confirm-modal">
        <Modal.Header>
          <div className="w-100 d-flex">
            <div className="col-md-6 m-auto">
              <span className="header-confirm">Confirmation</span>
            </div>
            <div className="col-md-6 text-right pr-0">
              <button className="btn btn-primary trademo-new-btn mx-2 px-2 " onClick={() => onDownload(type, downloadFromValue, downloadToValue, closeDownloadFromModal)}>
                Confirm
              </button>
              <button type="button" className="close trademo-modal-close" aria-label="Close" onClick={() => closeDownloadFromModal()}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <p className="modaltext mb-0">
            You are downloading list of{" "}
            <strong>
              {totalDataCount < downloadToValue ? totalDataCount - downloadFromValue + 1 : downloadToValue - downloadFromValue + 1} Prospect {type}
            </strong>{" "}
            which will cost you <strong>{(totalDataCount < downloadToValue ? totalDataCount - downloadFromValue + 1 : downloadToValue - downloadFromValue + 1) * credits[type]} Download Credits.</strong>
          </p>
        </Modal.Body>
      </Modal>
      {/* end of the above code */}
      {/* Below code is for Download Shipment */}
      <Modal size="sm" centered show={showDownloadShipmentModal} onHide={downloadShipmentPopupClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Download Shipments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row m-0">
            <div className="col-6 p-0">
              <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
              <span className="label-value line-height-32">
                Select Shipments by S.No <Info className="ml-1 cursor-pointer" color="#8C8C8C" size={13} data-tip="If selected count is more than 500, shipments are emailed." />
              </span>
            </div>
            <div className="col-6 p-0">
              <div className="row m-0">
                <div className="col-5 pr-0">
                  <input name="advanceSearchEntireBillLading" className="download-input-field" placeholder="From" type="number" value={downloadFromValue} onChange={(e) => mapDownloadFromValue(e.target.value)} min={1} />
                </div>
                <div className="col-2">
                  <span className="label-value line-height-32">to</span>
                </div>
                <div className="col-5 pr-0">
                  <input name="advanceSearchEntireBillLading" className="download-input-field" placeholder="To" type="number" value={downloadToValue} min={1} onChange={(e) => mapDownloadToValue(e.target.value)} />
                </div>
              </div>
            </div>
          </div>
          <div className="pt-0 text-right">{downloadToValue > 2000000 ? <span className="error">*Shipment download limit: Up to S.No 2,000,000</span> : <></>}</div>
          <div className="d-block text-right">{downloadFromValue && downloadToValue && downloadToValue - downloadFromValue > (!!isTrademoAccount && isTrademoAccount ? 249999 : 74999) ? <span className="error">*You can select maximum of {!!isTrademoAccount && isTrademoAccount ? commaFormat(250000) : commaFormat(75000)} at a time.</span> : <></>}</div>

          <div className="row w-100 m-0">
            <div className="col-5 my-2 px-0">
              <hr className="mx-0 w-100"></hr>
            </div>
            <div className="col-2 text-center my-2 line-height-32">
              <span className="label-key">Or</span>
            </div>
            <div className="col-5 my-2 px-0">
              <hr className="mx-0 w-100"></hr>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="form-check custom-inline-checkbox">
                <input className="form-check-input" type="checkbox" id="flexCheckDefault" value={selectAllDownloadFromPopup} checked={selectAllDownloadFromPopup === true} onChange={(e) => toggleSelectAllDownloadFromPopup(e)} disabled={!!totalDataCount && totalDataCount > (!!isTrademoAccount && isTrademoAccount ? 249999 : 74999)} />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  <span className="form-check-label">
                    Select all <span className="bold">{!!totalDataCount && totalDataCount > 0 ? commaFormat(totalDataCount) : 0}</span> Shipments
                  </span>
                </label>
              </div>
              {!!totalDataCount && totalDataCount > (!!isTrademoAccount && isTrademoAccount ? 249999 : 74999) ? <span className="d-block error py-2">*You can select maximum of {!!isTrademoAccount && isTrademoAccount ? commaFormat(250000) : commaFormat(75000)} at a time.</span> : <></>}
            </div>
          </div>
          <div className="row">
            <div className="col-12 mb-2 mt-3">{(!userCredit?.user_active_plan?.includes("enterprise") || userCredit?.is_free_trial === false) && <span className="download-credit-label">Note: Your download credits balance is {!!creditQuota && creditQuota.download_credits && creditQuota.download_credits && (!!creditQuota.download_credits.credit_limit || creditQuota.download_credits.credit_limit === 0) && (!!creditQuota.download_credits.credits_consumed || creditQuota.download_credits.credits_consumed === 0) ? commaFormat(creditQuota.download_credits.credit_limit - creditQuota.download_credits.credits_consumed) : ""}</span>}</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* {!!this.state.downloadShipmentCount && this.state.downloadShipmentCount > 0 ? <span className="mr-auto">Emailing {this.state.downloadShipmentCount} shipments.</span> : <></>} */}
          <button type="button" className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2" onClick={downloadShipmentPopupClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary btn-sm trademo-new-btn"
            disabled={(downloadFromValue === "" || downloadToValue === "" || downloadToValue > 2000000 || downloadToValue - downloadFromValue > (!!isTrademoAccount && isTrademoAccount ? 249999 : 74999)) && selectAllDownloadFromPopup === false ? true : false}
            onClick={() => {
              checkPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabDownloadExcelDownloadShipments);
              onDownload(downloadFromValue, downloadToValue, selectAllDownloadFromPopup, downloadShipmentPopupClose, isCustomGridDownload);
            }}>
            {isEmailShipments === false ? "Download" : "Email"}
          </button>
        </Modal.Footer>
      </Modal>
      {/* Start of Export to CRM by range modal code */}
      <Modal className="trademo-impexpmodal" centered show={showExportCrmConfirmModal} onHide={() => setShowExportCrmConfirmModal(false)} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Export Unique {type} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row m-0 ">
            <div className="col-6 p-0">
              <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
              <span className="label-value line-height-32">
                Select Unique {type} by S.No <Info className="ml-1 cursor-pointer" color="#8C8C8C" size={13} data-tip="If selected count is more than 500, shipments are emailed." />
              </span>
            </div>
            <div className="col-6 p-0">
              <div className="row m-0">
                <div className="col-5 pr-0">
                  <input
                    name="advanceSearchEntireBillLading"
                    className="download-input-field"
                    placeholder="From"
                    type="number"
                    value={exportFromValue}
                    onChange={(e) => {
                      mapExportFromValue(e.target.value);
                    }}
                  />
                </div>
                <div className="col-2">
                  <span className="label-value line-height-32">to</span>
                </div>
                <div className="col-5 pr-0">
                  <input
                    name="advanceSearchEntireBillLading"
                    className="download-input-field"
                    placeholder="To"
                    type="number"
                    value={exportToValue}
                    onChange={(e) => {
                      mapExportToValue(e.target.value);
                    }}
                  />
                </div>
              </div>
              {!!exportFromValue && !!exportFromValue && exportToValue - exportFromValue > 14999 ? (
                <div className="py-3">
                  <span className="error">*You can select maximum of 15000 at a time.</span>
                </div>
              ) : (
                <div className="py-3"></div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* {!!this.state.downloadShipmentCount && this.state.downloadShipmentCount > 0 ? <span className="mr-auto">Emailing {this.state.downloadShipmentCount} shipments.</span> : <></>} */}

          <div className="col-8 p-0 m-0">{(!userCredit?.user_active_plan?.includes("enterprise") || userCredit?.is_free_trial === false) && <span className="download-credit-label m-auto">Note: Your download credits balance is {!!creditQuota && !!creditQuota?.download_credits?.credit_limit && creditQuota?.download_credits?.credits_consumed !== undefined ? creditQuota.download_credits.credit_limit - creditQuota.download_credits.credits_consumed : ""}</span>}</div>
          <div className="col-4 p-0 m-0 d-flex justify-content-end">
            <button type="button" className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2" onClick={() => setShowExportCrmConfirmModal(false)}>
              Cancel
            </button>
            <button
              type="button"
              disabled={!exportFromValue || !exportToValue || exportToValue <= exportFromValue || exportToValue - exportFromValue > 14999 ? true : false}
              className="btn btn-primary btn-sm trademo-new-btn"
              onClick={() => {
                if (type && type.toLowerCase().includes("importer")) {
                  checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabDownloadExcelDownload);
                } else if (type && type.toLowerCase().includes("exporter")) {
                  checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabDownloadExcelDownload);
                } else if (type && type.toLowerCase().includes("logistics")) {
                  checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabDownloadExcelDownload);
                } else {
                  checkPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabSelectionStripDownloadConfirm);
                }
                const { activeCRM } = getIntegratedCRMInfo();
                setActiveCRM(activeCRM);
                setCrmCredConfirmation(true);
                setShowExportCrmConfirmModal(false);
              }}>
              {"Export"}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      {/* end of export to crm by range modal code */}
      {/* End of the Above code */}
      <Modal className="trademo-impexpmodal" centered show={showDownloadImpExpModal} onHide={downloadImpExpPopupClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Download Unique {type} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row m-0 ">
            <div className="col-6 p-0">
              <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
              <span className="label-value line-height-32">
                Select Unique {type} by S.No <Info className="ml-1 cursor-pointer" color="#8C8C8C" size={13} data-tip="If selected count is more than 500, shipments are emailed." />
              </span>
            </div>
            <div className="col-6 p-0">
              <div className="row m-0">
                <div className="col-5 pr-0">
                  <input name="advanceSearchEntireBillLading" className="download-input-field" placeholder="From" type="number" value={downloadFromValue} onChange={(e) => mapDownloadFromValue(e.target.value)} />
                </div>
                <div className="col-2">
                  <span className="label-value line-height-32">to</span>
                </div>
                <div className="col-5 pr-0">
                  <input name="advanceSearchEntireBillLading" className="download-input-field" placeholder="To" type="number" value={downloadToValue} onChange={(e) => mapDownloadToValue(e.target.value)} />
                </div>
              </div>
              {!!downloadFromValue && !!downloadToValue && downloadToValue - downloadFromValue > 9999 ? (
                <div className="py-3">
                  <span className="error">*You can select maximum of 10000 at a time.</span>
                </div>
              ) : (
                <div className="py-3"></div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* {!!this.state.downloadShipmentCount && this.state.downloadShipmentCount > 0 ? <span className="mr-auto">Emailing {this.state.downloadShipmentCount} shipments.</span> : <></>} */}

          <div className="col-8 p-0 m-0">{(!userCredit?.user_active_plan?.includes("enterprise") || userCredit?.is_free_trial === false) && <span className="download-credit-label m-auto">Note: Your download credits balance is {!!creditQuota && !!creditQuota?.download_credits?.credit_limit && creditQuota?.download_credits?.credits_consumed !== undefined ? creditQuota.download_credits.credit_limit - creditQuota.download_credits.credits_consumed : ""}</span>}</div>
          <div className="col-4 p-0 m-0 d-flex justify-content-end">
            <button type="button" className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2" onClick={downloadImpExpPopupClose}>
              Cancel
            </button>
            <button
              type="button"
              disabled={downloadFromValue === "" || downloadToValue === "" || downloadToValue - downloadFromValue > 9999 ? true : false}
              className="btn btn-primary btn-sm trademo-new-btn"
              onClick={() => {
                if (type && type.toLowerCase().includes("importer")) {
                  checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabDownloadExcelDownload);
                } else if (type && type.toLowerCase().includes("exporter")) {
                  checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabDownloadExcelDownload);
                } else if (type && type.toLowerCase().includes("logistics")) {
                  checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabDownloadExcelDownload);
                } else {
                  checkPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabSelectionStripDownloadConfirm);
                }
                showImporterConfirmModal();
              }}>
              {isEmailShipments === false ? "Download" : "Email"}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      {showDuplicateModal !== "" && showDuplicateModal ? <SalesforceDuplicateModal closeButton={() => closeDuplicateModalFunction()} showButton={showDuplicateModal} duplicateCount={duplicateCount} duplicateData={duplicateData} fuzzyData={fuzzyData} type="companies" /> : <></>}
      {showModal ? <AddFavModal profileType={profileType.company} show={showModal} handleClose={handleClose} prospectData={prospectData} type={type} tradeDirection={tradeDirection} country={country} dataSource={dataSource} modalType={MERGE} analyticsCountryID={analyticsCountryID} pathname={pathname} currentUserPlan={currentUserPlan} isRedirectProp={isRedirect} redirectingCompanyExporterId={redirectingCompanyExporterId} redirectingCompanyImporterId={redirectingCompanyImporterId} /> : <></>}
      {showContactModal ? (
        <ContactModal
          show={showContactModal}
          prospectData={prospectData}
          analyticsCountryID={analyticsCountryID}
          currentUserPlan={currentUserPlan}
          userFirstPlan={userFirstPlan}
          handleClose={() => {
            setShowContactModal(false);
            closeEventHandler();
            getUserPlan();
          }}
          type={type}
          triggerPendo={pendoEventHandler}
          closeEventHandler={closeEventHandler}
          remainingValueAddCount={remainingValueAddCount}
        />
      ) : (
        <></>
      )}
      {/* {showExportCrmConfirmModal && <ExportCrmConfirmModal showExportCrmConfirmModal={showExportCrmConfirmModal} setShowExportCrmConfirmModal={(val) => setShowExportCrmConfirmModal(val)} type={"Importers"} userCredit={userCredit} creditQuota={creditQuota} checkPendoEventForCompanyRedirection={checkPendoEventForCompanyRedirection} />} */}
      {showFavModal ? <AddFavModal profileType={type.toLowerCase() === "logistics" ? profileType.logistics : profileType.company} show={showFavModal} handleClose={handleFavModalClose} prospectData={prospectData} type={type} tradeDirection={tradeDirection} country={country} dataSource={dataSource} analyticsCountryID={analyticsCountryID} pathname={pathname} currentUserPlan={currentUserPlan} isRedirectProp={isRedirect} /> : <></>}
      {showAddWorkspaceModal ? (
        <AddCompaniesToWorkspaceModal
          show={showAddWorkspaceModal}
          onHide={() => setShowAddWorkspaceModal(false)}
          companies={prospectData}
          type={workspaceCompanyType}
          workspaceCreationFilters={workspaceCreationFilters}
          searchApiEndpoint={defaultData?.apiEndPoints?.getSearchResult}
          source={source}
          onSuccess={() => {
            setShowAddWorkspaceModal(false);
            onClear?.(type);
          }}
        />
      ) : (
        <></>
      )}
      {/* Introducing Workspace nudge — anchors to the Add to Workspace button (importer/exporter UI-UE tables).
          Uses its own per-module key so it shows once for UI-UE independently of Product/Company Search. */}
      <FeatureNudge nudgeKey="workspace_ui_ue" enabled={isWorkspaceSupportedType} />
      {showCrmModal && !isSalesforceUser && !isZohoUser && !isHubspotUser ? <ExportCrmModal show={showCrmModal} handleClose={handleCrmModalClose} activeTab={type} /> : <></>}
    </>
  );
};
export default TabHeader;
